import { render, staticRenderFns } from "./jobList.vue?vue&type=template&id=10fa4042&"
import script from "./jobList.vue?vue&type=script&lang=js&"
export * from "./jobList.vue?vue&type=script&lang=js&"
import style0 from "./jobList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports